/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

import React from 'react';
import { useLanguage } from '@/providers/LanguageProvider';

import { Icons } from '../icons';

const AutoDiscoveredBadge = ({ color }: { color?: string }) => {
  const { messages } = useLanguage();
  return (
    <div className="flex items-center gap-3">
      <div
        className={`flex h-6 items-center gap-1 rounded-3xl ${color ? `bg-[${color}]` : 'bg-[#257C9D]'} pl-2 pr-3 text-body-sm text-white`}
      >
        {Icons.AutoDetected({
          iconBg: color ? `bg-[${color}]` : 'bg-[#257C9D]',
        })}
        {messages?.General?.auto_detected}
      </div>
    </div>
  );
};

export default AutoDiscoveredBadge;
